@if (panel.isVisible()) {
  <!-- Backdrop -->
  <div
    class="so-backdrop"
    [class.closing]="panel.closing()"
    (click)="onBackdropClick()"
    aria-hidden="true">
  </div>

  <!-- Panel -->
  <aside
    class="so-panel"
    [class.closing]="panel.closing()"
    [class.resizing]="isResizing()"
    [style.width.px]="panelWidth()"
    role="dialog"
    aria-modal="true"
    [attr.aria-label]="panel.config().title"
    cdkTrapFocus
    [cdkTrapFocusAutoCapture]="true">

    <!-- Resize Handle -->
    <div
      class="so-resize-handle"
      (mousedown)="onResizeStart($event)"
      (touchstart)="onResizeStart($event)"
      aria-hidden="true">
      <div class="so-resize-bar"></div>
    </div>

    <!-- Header (sticky) -->
    <header class="so-header">
      <div class="so-header-content">
        <div class="so-title-row">
          <div class="so-title-group">
            <h2 class="so-title">{{ panel.config().title }}</h2>
            @if (panel.config().subtitle; as subtitle) {
              <span class="so-subtitle">{{ subtitle }}</span>
            }
          </div>
          @if (panel.config().status; as status) {
            <span class="so-status-badge" [class]="statusClass()">
              {{ status.label }}
            </span>
          }
        </div>
      </div>
      <div class="so-header-actions">
        @if (panel.headerActionsTemplate(); as actionsTmpl) {
          <ng-container
            *ngTemplateOutlet="actionsTmpl; context: { $implicit: panel.templateContext() }">
          </ng-container>
        }
        <button
          class="so-close-btn"
          (click)="panel.close()"
          aria-label="Schließen"
          type="button">
          <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
            <path d="M14 4L4 14M4 4l10 10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
          </svg>
        </button>
      </div>
    </header>

    <!-- Scrollable Body -->
    <div class="so-body">
      @if (panel.bodyTemplate(); as tmpl) {
        <ng-container
          *ngTemplateOutlet="tmpl; context: { $implicit: panel.templateContext() }">
        </ng-container>
      }
    </div>

    <!-- Footer (sticky, only rendered when footer template exists) -->
    @if (panel.footerTemplate(); as footerTmpl) {
      <footer class="so-footer">
        <ng-container
          *ngTemplateOutlet="footerTmpl; context: { $implicit: panel.templateContext() }">
        </ng-container>
      </footer>
    }
  </aside>
}
